package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordSignSymptomState(private val literal: String) : IEnumType {
	存在("存在"),
	不存在("不存在"),
	说不清楚("说不清楚");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_sign_symptom_state"}
	override fun getLiteral(): String {return literal}
}
